<div class="ui-g-12">

  <div class="ui-g">
    <div *ngFor="let indicator of indicators" class="ui-g-12 ui-md-3 ui-sm-6">
      <app-infobox [pointData]="indicator.pointData" [penetration]="indicator.penetration" [options]="indicator.options"></app-infobox>
    </div>
  </div>

  <div class="ui-g-12 ui-md-6 ui-sm-12"  *ngIf="data != null">
    <h2>{{ 'promo.investmentPerPromoType' | translate }}</h2>
    <div class="chart-container">
      <chart [options]="categoryInvestmentPie.options"
             (load)="setChartInstance(categoryInvestmentPie, $event.context)"></chart>
    </div>
  </div>

  <div class="ui-g-12 ui-md-6 ui-sm-12"  *ngIf="data != null">
    <h2>{{ 'promo.categoryInvestmentTypePromo' | translate }}</h2>
    <div class="chart-container">
      <chart [options]="categoryInvestmentColumn.options"
             (load)="setChartInstance(categoryInvestmentColumn, $event.context)"></chart>
    </div>
  </div>

  <div class="ui-g-12 ui-md-6 ui-sm-12"  *ngIf="data != null">
    <h2>{{ 'promo.averageDiscountPerStoreChannel' | translate }}</h2>
    <div class="chart-container">
      <chart [options]="averageDiscount.options"
             (load)="setChartInstance(averageDiscount, $event.context)"></chart>
    </div>
  </div>

  <div class="ui-g-12 ui-md-6 ui-sm-12"  *ngIf="data != null">
    <h2>{{ 'promo.investmentContactChannel' | translate }}</h2>
    <div class="chart-container">
      <chart [options]="investmentContactPie.options"
             (load)="setChartInstance(investmentContactPie, $event.context)"></chart>
    </div>
  </div>

  <p-dialog header="Error" [(visible)]="storeError" [width]="300" [modal]="true" [draggable]="false" [resizable]="false">
    <p>{{ 'store.selectOneErrorMsg' | translate }}</p>
    <div class="ui-dialog-footer">
      <button pButton type="button" class="slim red-button" (click)="toogleErrorStoreDialog()" label="Ok"></button>
    </div>
  </p-dialog>

</div>



// WEBPACK FOOTER //
// ./src/app/views/analytics/promo/overview/overview-main-kpi/promo-overview-main-kpi.component.html